import { useState } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../datos/db.js'
import { buscarClientes } from '../datos/consultas.js'
import { TituloPagina } from '../comunes/AppShell.js'

/**
 * Lista de pacientes (T22).
 *
 * Es la mitad izquierda de lo que antes era `Fichas.tsx`: el buscador sobre
 * Dexie, los recientes, y las filas con nombre y contacto. Elegir un paciente
 * no abre nada acá: el detalle lo maneja el eje del paciente en el banner.
 *
 * La búsqueda sigue siendo local, sin red: sobre Dexie, instantánea.
 */

export function Pacientes({
  elegido,
  onElegir,
}: {
  elegido: string | null
  onElegir: (clienteId: string) => void
}) {
  const [texto, setTexto] = useState('')

  // La búsqueda es local: sobre Dexie, sin red y sin espera.
  const resultados = useLiveQuery(() => buscarClientes(texto), [texto], [])
  const recientes = useLiveQuery(
    () => db.cliente.orderBy('nombre').limit(15).toArray(),
    [],
    [],
  )

  const lista = texto.trim().length >= 2 ? resultados : recientes

  return (
    <div>
      <TituloPagina
        titulo="Pacientes"
        bajada="Buscá por nombre, teléfono o documento"
      />

      <div className="mb-4">
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="Buscar por nombre, teléfono o documento"
          className="min-h-10 w-full rounded-lg border border-slate-300 px-3 text-sm"
        />
      </div>

      {lista.length === 0 ? (
        <p className="py-8 text-center text-sm text-slate-400">
          {texto.trim().length >= 2 ? 'Nadie con ese dato.' : 'Todavía no hay pacientes.'}
        </p>
      ) : (
        <ul className="divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-white">
          {lista.map((c) => (
            <li key={c.id}>
              <button
                type="button"
                onClick={() => onElegir(c.id)}
                className={`w-full px-4 py-3 text-left hover:bg-slate-50 ${
                  elegido === c.id ? 'bg-teal-50' : ''
                }`}
              >
                <span className="block truncate text-sm font-medium text-slate-800">
                  {c.nombre}
                </span>
                <span className="block truncate text-xs text-slate-500">
                  {c.telefono ?? c.doc ?? 'sin contacto'}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
